import datapoints from '../../datapoints';
import { FolderForestNodeType } from 'owa-favorites-types';
import { action } from 'satcheljs';

export default action(
    'MOVE_FAVORITE_UP_DOWN_V2',
    (favoriteId: string, isMoveUp: boolean, favoriteType: FolderForestNodeType) => {
        return {
            favoriteId,
            isMoveUp,
            favoriteType,
            datapointConfig: datapoints.MoveOutlookFavoritesUpDown.datapoint,
        };
    }
);
